"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixOverbraces = fixOverbraces;
const tex_syntax_1 = require("./tex-syntax");
function fixOverbraces(tex) {
    return tex.replace(new RegExp(`(\\\\overbrace)(\\\\${tex_syntax_1.color}${(0, tex_syntax_1.arg)(1)})`, "g"), "$1{$2}");
}
